import React, { FC } from 'react'
import { Card, Grid, Typography } from 'antd'
import { css } from '@emotion/css'
const { Title } = Typography 

interface ActivityCardProps {
  title: string
  icon?: React.ReactNode
  children?: React.ReactNode
  actions?: React.ReactNode[]
  description?: string | React.ReactNode
}

const { Meta } = Card

export const ActivityCard: FC<ActivityCardProps> = ({ 
  title, 
  children, 
  icon, 
  actions,
  description
}) => {
  const { xs } = Grid.useBreakpoint()

  return (
    <Card
      size={xs ? 'small' : 'default'}
      style={{
        width: '100%',
      }}
      headStyle={{
        margin: 0,
        padding: xs ? '0 6px' : '0 12px',
      }}
      actions={actions}
      className={css`
        ul, li {
          margin: 0;
          padding: 0;
        }  
      `
      }
    >
      <Meta
        avatar={icon}
        title={title}
        description={description}
      />
      {children}
    </Card>
  )
}
